// © Microsoft Corporation. All rights reserved.

import { WebStorage } from "./WebStorage";
import { canUseDOM } from "@msnews/isomorphic-util";

/**
 * Local storage class for persistent storage
 */
export class LocalStorage extends WebStorage {
    constructor() {
        let storage: Storage = null;

        if (canUseDOM()) {
            try {
                storage = window.localStorage;
            } catch (ex) {
                // Getting local storage failed. Can happen in Chrome when user has disabled cookies.
            }
        }

        super(storage);
    }
}

/**
 * Set the local storage instance. Useful when setting up mock storage instance.
 * @param _storage The local storage instance to change to.
 */
export function setLocalStorage(_storage: WebStorage): void {
    localStorage = _storage;
}

export let localStorage: WebStorage = new LocalStorage();